import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";

export default function Chart({ data, type }) {
  const wrapperClass = "w-full h-96 bg-white rounded shadow-lg p-4 my-6";

  const chartData = Array.isArray(data) ? data : data?.data || [];
  const params = Array.isArray(data) ? {} : data?.params || {};

  switch (type) {
    case "piechart": {
      // Paramètres par défaut pour les graphiques en secteurs, avec possibilité de les surcharger via les données
      const defaultPie = {
        margin: { top: 40, right: 80, bottom: 40, left: 80 },
        innerRadius: 0.5,
      };

      return (
        <div className={wrapperClass}>
          <ResponsivePie data={chartData} {...defaultPie} {...params} />
        </div>
      );
    }

    case "barchart": {
      const indexBy = params.indexBy ?? "year";
      const keys =
        params.keys ??
        (chartData[0]
          ? Object.keys(chartData[0]).filter((key) => key !== indexBy)
          : []);

      // RETURN
      return (
        <div style={{ fontSize: params.fontSize || 16 }}>
          {/* TITRE */}
          {params.title && <div style={params.titleStyle}>{params.title}</div>}

          {/* ZONE GRAPHIQUE : elle seule a une hauteur fixe */}
          <div style={{ height: params.height || 500 }}>
            <ResponsiveBar
              data={chartData}
              keys={keys}
              indexBy={indexBy}
              /* DEFAULTS */
              padding={0.3}
              labelSkipWidth={12}
              labelSkipHeight={12}
              borderColor={{ from: "color" }}
              animate={true}
              /* PARAMS JSON */
              {...params}
              /* LABELS */
              label={(d) => d.formattedValue}
            />
          </div>

          {/* LEGENDE CUSTOM */}
          {params.useCustomLegend && (
            <div
              style={{
                display: "flex",
                flexDirection: params.legendLayout?.direction || "row",
                gap: params.legendLayout?.gap || 20,
                marginTop: params.legendLayout?.marginTop || 20,
                marginLeft: params.legendLayout?.marginLeft || 0,
                marginBottom: params.legendLayout?.marginBottom || 50,
                flexWrap: "wrap",
              }}
            >
              {params.legendGroups?.map((group) => (
                <div
                  key={group.label}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: params.legendLayout?.itemWidth || 200,
                    height: params.legendLayout?.itemHeight || 20,
                    whiteSpace: "nowrap",
                  }}
                >
                  {/* Pastilles */}
                  <div style={{ display: "flex", marginRight: 8 }}>
                    {group.keys.map((key, i) => (
                      <span
                        key={i}
                        style={{
                          width: params.legendDotSize || 10,
                          height: params.legendDotSize || 10,
                          borderRadius: "50%",
                          backgroundColor:
                            params.colors?.[params.keys.indexOf(key)],
                          marginRight: 10,
                          display: "inline-block",
                        }}
                      />
                    ))}
                  </div>

                  <span style={params.legendTextStyle}>{group.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    }

    case "linechart": {
      return (
        <div className={wrapperClass}>
          <ResponsiveLine
            data={chartData}
            colors={params.colors}
            margin={params.margin}
            useMesh={params.useMesh ?? true}
            animate={true}
            pointSize={params.pointSize ?? 7}
            tooltip={({ point }) => (
              <div
                style={{
                  background: "#fff",
                  color: "#222",
                  fontSize: 12,
                  borderRadius: 6,
                  padding: "12px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                }}
              >
                {point.data.yFormatted}
              </div>
            )}
            /* PARAMS JSON */
            {...params}
          />
        </div>
      );
    }

    default:
      return (
        <div className="my-4 text-red-500">
          Type de graphique inconnu : {type}
        </div>
      );
  }
}
